import React, { useState } from 'react';
import styles from './ProjectToggleButton.module.css';

interface ProjectToggleButtonProps {
  projectInfo: string;
}

const ProjectToggleButton: React.FC<ProjectToggleButtonProps> = ({ projectInfo }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <div 
          className={`${styles.projectText} ${isExpanded ? styles.show : styles.hide}`}
        >
          {projectInfo}
        </div>
      </div>
      
      <button 
        className={styles.toggleButton}
        onClick={handleClick}
        aria-label={isExpanded ? 'Nascondi progetto' : 'Mostra progetto'}
      >
        {isExpanded ? '−' : '+'}
      </button>
    </div>
  );
};

export default ProjectToggleButton;
